var q = Object.defineProperty, A = Object.defineProperties;
var H = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var v = (e, a, r) => a in e ? q(e, a, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[a] = r, t = (e, a) => {
  for (var r in a || (a = {}))
    y.call(a, r) && v(e, r, a[r]);
  if (p)
    for (var r of p(a))
      x.call(a, r) && v(e, r, a[r]);
  return e;
}, l = (e, a) => A(e, H(a));
var S = (e, a) => {
  var r = {};
  for (var o in e)
    y.call(e, o) && a.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && p)
    for (var o of p(e))
      a.indexOf(o) < 0 && x.call(e, o) && (r[o] = e[o]);
  return r;
};
import { jsx as i, jsxs as F, Fragment as J } from "react/jsx-runtime";
import { forwardRef as K } from "react";
import { c as L, a as M } from "./get-size-Bc1Pz5yf.js";
import { u as O } from "./use-styles-DToiHEa6.js";
import { B as m } from "./factory-ueRxoNOV.js";
import { I as g, u as P } from "./Input--FNE961U.js";
var B = { root: "m_5f75b09e", body: "m_5f6e695e", labelWrapper: "m_d3ea56bb", label: "m_8ee546b8", description: "m_328f68c0", error: "m_8e8a99cc" };
const ee = B, Q = K(
  (U, k) => {
    var h = U, {
      __staticSelector: e,
      __stylesApiProps: a,
      className: r,
      classNames: o,
      styles: W,
      unstyled: j,
      children: C,
      label: b,
      description: c,
      id: f,
      disabled: u,
      error: d,
      size: s,
      labelPosition: w = "left",
      bodyElement: I = "div",
      labelElement: _ = "label",
      variant: D,
      style: G,
      vars: T,
      mod: N
    } = h, R = S(h, [
      "__staticSelector",
      "__stylesApiProps",
      "className",
      "classNames",
      "styles",
      "unstyled",
      "children",
      "label",
      "description",
      "id",
      "disabled",
      "error",
      "size",
      "labelPosition",
      "bodyElement",
      "labelElement",
      "variant",
      "style",
      "vars",
      "mod"
    ]);
    const n = O({
      name: e,
      props: a,
      className: r,
      style: G,
      classes: B,
      classNames: o,
      styles: W,
      unstyled: j
    });
    return /* @__PURE__ */ i(
      m,
      l(t(l(t({}, n("root")), {
        ref: k,
        __vars: {
          "--label-fz": M(s),
          "--label-lh": L(s, "label-lh")
        },
        mod: [{ "label-position": w }, N],
        variant: D,
        size: s
      }), R), {
        children: /* @__PURE__ */ F(
          m,
          l(t({
            component: I,
            htmlFor: I === "label" ? f : void 0
          }, n("body")), {
            children: [
              C,
              /* @__PURE__ */ F("div", l(t({}, n("labelWrapper")), { "data-disabled": u || void 0, children: [
                b && /* @__PURE__ */ i(
                  m,
                  l(t({
                    component: _,
                    htmlFor: _ === "label" ? f : void 0
                  }, n("label")), {
                    "data-disabled": u || void 0,
                    children: b
                  })
                ),
                c && /* @__PURE__ */ i(g.Description, l(t({ size: s, __inheritStyles: !1 }, n("description")), { children: c })),
                d && typeof d != "boolean" && /* @__PURE__ */ i(g.Error, l(t({ size: s, __inheritStyles: !1 }, n("error")), { children: d }))
              ] }))
            ]
          })
        )
      })
    );
  }
);
Q.displayName = "@mantine/core/InlineInput";
function re({ children: e, role: a }) {
  const r = P();
  return r ? /* @__PURE__ */ i("div", { role: a, "aria-labelledby": r.labelId, "aria-describedby": r.describedBy, children: e }) : /* @__PURE__ */ i(J, { children: e });
}
export {
  re as I,
  Q as a,
  ee as b
};
